export const FR7 = {
  "General": "Général",
  "All": "Tous",
  "active": "actif",
  "unread": "non lus",
  "Management report": "Rapport de direction",
  "Certificate": "Certificat",
  "Something went wrong. Please try again.": "Une erreur est survenue. Veuillez réessayer.",
  "An account with this email already exists.": "Un compte existe déjà avec cette adresse e-mail.",
  "Assessment not found": "Évaluation introuvable",
  "Certificate not found": "Certificat introuvable",
  "Client not found": "Client introuvable",
  "Client profile not found": "Profil client introuvable",
  "Current password is incorrect.": "Le mot de passe actuel est incorrect.",
  "Email not found": "Adresse e-mail introuvable",
  "File not found": "Fichier introuvable",
  "Invalid email or password.": "E-mail ou mot de passe invalide.",
  "Invalid payload": "Données invalides",
  "Invalid session": "Session invalide",
  "Invalid status": "Statut invalide",
  "New password must be different from the current password.": "Le nouveau mot de passe doit être différent du mot de passe actuel.",
  "Not authenticated": "Non authentifié",
  "Password must be at least 8 characters and contain a letter and a number.": "Le mot de passe doit contenir au moins 8 caractères, dont une lettre et un chiffre.",
  "Passwords do not match.": "Les mots de passe ne correspondent pas.",
  "Report not found": "Rapport introuvable",
  "Service request not found": "Demande de service introuvable",
  "Submission not found": "Soumission introuvable",
  "This reset link is invalid or has expired.": "Ce lien de réinitialisation est invalide ou a expiré.",
  "Too many failed attempts. Please try again in 15 minutes.": "Trop de tentatives échouées. Veuillez réessayer dans 15 minutes.",
  "Unable to upload this file. Please make sure it is a PDF.": "Impossible de téléverser ce fichier. Assurez-vous qu'il s'agit d'un PDF.",
  "Unauthorized": "Non autorisé",
  "Unknown assessment type": "Type d'évaluation inconnu",
  "Unknown service": "Service inconnu",
  "User not found": "Utilisateur introuvable",
  "You do not have permission to access this resource.": "Vous n'avez pas l'autorisation d'accéder à cette ressource.",
  "You must agree to the ESAIA Terms and Privacy Policy.": "Vous devez accepter les conditions ESAIA et la politique de confidentialité.",
  "Your session has expired. Please log in again.": "Votre session a expiré. Veuillez vous reconnecter.",
  "for": "pour",
  "My Portal": "Mon portail",
  "Admin Portal": "Portail admin",
  "ERI completed": "ERI terminé",
  "Website enquiry": "Demande via le site",
  "Anonymous": "Anonyme",
  "Saving...": "Enregistrement...",
  "Language": "Langue",
  "Ethical Standards for Artificial Intelligence Assurance": "Normes éthiques pour l'assurance de l'intelligence artificielle",
};
